export const editProfileStatusTranslations = {
  en: {
    title: "Edit Profile Status",
    selectStatusLabel: "Select New Status",
    reasonLabel: "Reason",
    reasonRequired: "Reason is required for Archived or Suspended status",
    reasonPlaceholder: "Enter reason for status change...",
    currentStatusPrefix: "Current Status:",
    cancelButton: "Cancel",
    saveButton: "Save",
    savingButton: "Saving...",
    status_toast_message: "Profile status updated successfuly"
  },
  de: {
    title: "Profilstatus bearbeiten",
    selectStatusLabel: "Neuen Status auswählen",
    reasonLabel: "Grund",
    reasonRequired: "Grund ist erforderlich für Archivierten oder Suspendierten Status",
    reasonPlaceholder: "Grund für Statusänderung eingeben...",
    currentStatusPrefix: "Aktueller Status:",
    cancelButton: "Abbrechen",
    saveButton: "Speichern",
    savingButton: "Speichern...",
    status_toast_message: "Profilstatus erfolgreich aktualisiert"
  },
  hr: {
    title: "Uredi status profila",
    selectStatusLabel: "Odaberite novi status",
    reasonLabel: "Razlog",
    reasonRequired: "Razlog je obavezan za arhivirani ili suspendirani status",
    reasonPlaceholder: "Unesite razlog promjene statusa...",
    currentStatusPrefix: "Trenutni status:",
    cancelButton: "Otkaži",
    saveButton: "Uštedjeti",
    savingButton: "Spremanje...",
    status_toast_message: "Status profila uspješno ažuriran"
  }
};
